// extracted by mini-css-extract-plugin
module.exports = {"form":"forgotPassword_form__vViY6","loading":"forgotPassword_loading__GqO9W","branding":"forgotPassword_branding__bDOqQ"};